import appConstants from '../constants/appConstants';
import checkCredentials from '../authentication/checkCredentials';

function deleteTargetUserProfile(currUsername, currEmail, currId) {
  return new Promise((resolve, reject) => {
    checkCredentials().then(() => {
      var docClient = new AWS.DynamoDB.DocumentClient();
      var params;

      var schoolName = localStorage.zmailSchoolName;
      var email = currEmail;
      var username = currUsername;
      var userId = username + '-us-east-1:' + currId;

      params = {
        TableName: appConstants.USER_TABLE,
        Key: {
          id: userId,
        },
      };

      docClient.delete(params, (err, data) => {
        if (err) reject(err);
        else {
          console.log(data);
          return data;
        }
      });

      // docClient.get(params).promise()
      // .then((dataObj) => {
      //   console.log(dataObj);
      //   var ItemObj = null;

      //   if (dataObj!=null && Object.keys(dataObj).length>0) {
      //     ItemObj = dataObj.Item;
      //     ItemObj.email = email;
      //   }
      //   else {
      //     ItemObj = {
      //       id: userId,
      //       NewProspectsList: {},
      //       NotifSettings: {},
      //       POIList: {},
      //       RatingBumpList: {},
      //       TrackedPlayers: {},
      //       hiddenPlayers: [],
      //       school: schoolName,
      //       username: username,
      //       email: email,
      //     }
      //   }
    });
  });
}

export default deleteTargetUserProfile;



// WEBPACK FOOTER //
// ./src/userFunctions/deleteTargetUserProfile.js